import React from "react"
import { initializeApp } from "firebase/app"
import { getMessaging, getToken, onMessage } from "firebase/messaging"
import { toast } from "react-toastify"
import api from "./api"

const firebaseConfig = {
  apiKey: "AIzaSyDIKQYlJGpUNxJutBZrAOV4LejpHAYNQMM",
  authDomain: "patameds-58fed.firebaseapp.com",
  projectId: "patameds-58fed",
  storageBucket: "patameds-58fed.firebasestorage.app",
  messagingSenderId: "232214220388",
  appId: "1:232214220388:web:a9a35a1763730d7d755971",
  measurementId: "G-Q914W7JKFK",
}

const vapidKey =
  "BAnVkjaHuf0nz-_AIFAzlEMjFA5WZXU7Y7kEsQXAGflqTVAwtzK9-g-YqjxeeuuluHgqcljrLWEDVFhx0Bxak_o"

const app = initializeApp(firebaseConfig)
let messaging = null

export const requestFCMToken = async () => {
  try {
    // Check if notifications are supported
    if (!("Notification" in window)) {
      throw new Error("Notifications are not supported in this browser")
    }

    // Request notification permission
    const permission = await Notification.requestPermission()
    if (permission !== "granted") {
      throw new Error("Notification permission denied")
    }

    // Ensure service worker is registered
    if ("serviceWorker" in navigator) {
      await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
        scope: "/",
      })
    }

    // Get messaging instance and token
    messaging = getMessaging(app)
    const token = await getToken(messaging, { vapidKey })
    return token
  } catch (error) {
    console.error("Error requesting FCM token:", error)
    throw error
  }
}

export const registerFCMToken = async () => {
  try {
    const token = await requestFCMToken()

    if (token && window.localStorage.getItem("token")) {
      await api().post("/users/fcm-token", { token })
    }

    return token
  } catch (error) {
    console.error("Error registering FCM token:", error)
    return null
  }
}

export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (!messaging) {
      console.warn("Messaging not initialized. Call requestFCMToken first.")
      return
    }
    onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload)
      const link = payload.data?.url || payload.data?.link
      const content = (
        <>
          <strong>{payload.notification.title}</strong>
          <p>{payload.notification.body}</p>
        </>
      )

      toast(
        link ? (
          <button
            onClick={() => {
              window.location.assign(link)
            }}
            style={{
              all: "unset",
              cursor: "pointer",
              display: "block",
              textAlign: "left",
            }}
            type="button"
          >
            {content}
          </button>
        ) : (
          <div>{content}</div>
        ),
        { position: "top-right" }
      )
      resolve(payload)
    })
  })
}
